import { HsColor } from '../math-new/objects/color.class';
import { HsMatrix4 } from '../math-new/objects/matrix4.class';
import { HsVector3 } from '../math-new/objects/vector3.class';
import { HsSubject } from '../reactive-new/classes/subject.class';
import type { HsOutputMessageObject } from './messages/output-message-object.class';

export namespace HsGlobal {
  export const ROTATE_POINT: HsVector3 = HsVector3.makeZeroVector();
  export const TARGET_MATRIX: HsMatrix4 = HsMatrix4.makeIdentityMatrix();
  export const WHITE_COLOR: HsColor = HsColor.makeWhite();
  export const outputMessages: HsSubject<HsOutputMessageObject> = new HsSubject<HsOutputMessageObject>();
}
